@if (apps.length > 0) {
  <div class="mat-elevation-z8">
    <table mat-table class="stripped-table" #taxCreditAppsTable [dataSource]="dataSource" matSort>
      <!-- Credit Type Column -->
      <ng-container matColumnDef="credit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Credit Type </th>
        <td mat-cell class="name-column" *matCellDef="let row"> {{row.credit}}
          @if (permissions.applicationPermissions._edit) {
            <span class="subsection">
              <span class="save-icon">
                <button mat-mini-fab (click)="toggleEditMode(row)">
                  @if (!row.isEditMode) {
                    <mat-icon>edit</mat-icon>
                  }
                  @if (row.isEditMode) {
                    <mat-icon>save</mat-icon>
                  }
                </button>
              </span>
            </span>
          }
        </td>
      </ng-container>
      <!-- Awarded Column -->
      <ng-container matColumnDef="awarded">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Awarded </th>
        <td mat-cell *matCellDef="let row">
          @if (!row.isEditMode) {
            <span>{{row.awarded}}</span>
          }
          @if (row.isEditMode) {
            <mat-form-field>
              <mat-label>Select Application Status</mat-label>
              <mat-select [(value)]="row.awardedNew">
                <mat-option [value]="true">Awarded</mat-option>
                <mat-option [value]="false">Not Awarded</mat-option>
                <mat-option [value]="'n/a'">N/A</mat-option>
              </mat-select>
            </mat-form-field>
          }
        </td>
      </ng-container>
      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount Requested </th>
        <td mat-cell *matCellDef="let row; let i = index;">
          @if (!row.isEditMode) {
            <span>{{row.amount}}</span>
          }
          @if (row.isEditMode) {
            <mat-form-field class="example-full-width">
              <input type="number" matInput
                placeholder="Enter amount"
                [value]="row.amountNew"
                (input)="updateAmount($event, i)"
                required>
            </mat-form-field>
          }
        </td>
      </ng-container>
      <!-- Request Date Column -->
      <ng-container matColumnDef="requestDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Request Date </th>
        <td mat-cell *matCellDef="let row; let i = index;">
          @if (!row.isEditMode) {
            <span>{{row.requestDate}}</span>
          }
          @if (row.isEditMode) {
            <span class="value-column">
              <mat-form-field appearance="fill">
                <mat-label>Enter a date</mat-label>
                <input matInput [matDatepicker]="datepicker" (dateChange)="changeDate($event, i)" [value]="row.newDate">
                <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker>
                </mat-datepicker>
              </mat-form-field>
              <button mat-icon-button color="warn" aria-label="Delete Application" (click)="deleteApp(row, i)">
                <mat-icon>clear</mat-icon>
              </button>
            </span>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="dataColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: dataColumns;"></tr>
    </table>
  </div>
}
